import React from 'react';
import {motion} from 'framer-motion';
import {Camera, Lock, Network, Server, Shield, Wifi} from 'lucide-react';

const services = [
    {
        icon: Camera,
        title: 'Montaż Kamer i Monitoringu',
        desc: 'Zyskaj pełną kontrolę nad swoją posesją. Kamery IP 4K, obrotowe PTZ i rejestratory z podglądem na żywo w telefonie 24/7. Profesjonalny montaż monitoringu w Mielcu i promieniu do 250 km (Rzeszów, Tarnów, Dębica, Stalowa Wola, Tarnobrzeg, Kolbuszowa, Sandomierz, Kraków, Kielce).',
        color: 'from-blue-500/20 to-cyan-500/20',
        iconColor: 'text-blue-500',
    },
    {
        icon: Shield,
        title: 'Systemy Alarmowe',
        desc: 'Reaguj natychmiast na każde zagrożenie. Inteligentne alarmy z powiadomieniem GSM na telefon, czujniki ruchu, dymu, zalania oraz kontaktrony. Bezpieczeństwo Twojej rodziny i mienia w Mielcu i okolicach.',
        color: 'from-emerald-500/20 to-teal-500/20',
        iconColor: 'text-emerald-500',
    },
    {
        icon: Lock,
        title: 'Domofony i Kontrola Dostępu',
        desc: 'Wiedz, kto stoi przed bramą lub drzwiami, zanim otworzysz. Wideodomofony IP z aplikacją na telefon, zamki szyfrowe i czytniki RFID. Pełna kontrola nad wejściem z dowolnego miejsca.',
        color: 'from-violet-500/20 to-purple-500/20',
        iconColor: 'text-violet-500',
    },
    {
        icon: Network,
        title: 'Sieci Komputerowe i WiFi MESH',
        desc: 'Szybki i stabilny internet bez zrywania zasięgu. Okablowanie strukturalne LAN kategorii 6, instalacja WiFi MESH i szaf teletechnicznych w domach jednorodzinnych, biurach i magazynach.',
        color: 'from-amber-500/20 to-orange-500/20',
        iconColor: 'text-amber-500',
    },
    {
        icon: Server,
        title: 'Cyberbezpieczeństwo Firm',
        desc: 'Chroń dane swojej firmy przed atakami ransomware i kradzieżą. Audyty bezpieczeństwa, firewalle, bezpieczne tunele VPN i ochrona antywirusowa ESET.',
        color: 'from-rose-500/20 to-pink-500/20',
        iconColor: 'text-rose-500',
    },
    {
        icon: Wifi,
        title: 'Outsourcing IT dla Firm',
        desc: 'Skup się na rozwoju biznesu. Przejmujemy kompleksową opiekę nad Twoją infrastrukturą IT: serwery, kopie zapasowe, monitoring sieci i szybka reakcja serwisowa na Podkarpaciu i do 250 km.',
        color: 'from-sky-500/20 to-indigo-500/20',
        iconColor: 'text-sky-500',
    },
];

export function ServicesSection() {
    return (
        <section
            id="uslugi"
            className="w-full scroll-mt-20 py-20 md:py-28 px-5 bg-background"
        >
            <div className="max-w-6xl mx-auto">
                <motion.div
                    initial={{opacity: 0}}
                    whileInView={{opacity: 1}}
                    viewport={{once: true}}
                    className="text-center mb-16"
                >
                    <div
                        className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-border bg-muted/50 text-xs md:text-sm font-medium text-muted-foreground mb-4">
                        Monitoring Mielec i okolice
                    </div>
                    <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight mb-4">
                        Kompleksowe{' '}
                        <span className="text-primary">zabezpieczenia</span> dla Mielca i okolic
                    </h2>
                    <p className="text-muted-foreground max-w-xl mx-auto">
                        Od kamer CCTV i alarmów po sieci komputerowe i blokadę reklam WiFi. 
                        Wszystko, czego potrzebujesz, aby Twój dom i firma w Mielcu oraz w promieniu do 250 km były w 100% bezpieczne.
                    </p>
                </motion.div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {services.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <motion.div
                                key={s.title}
                                initial={{opacity: 0}}
                                whileInView={{opacity: 1}}
                                viewport={{once: true}}
                                transition={{duration: 0.5, delay: i * 0.08}}
                                className="relative rounded-2xl border border-border p-5 md:p-6 flex items-start gap-4 bg-card overflow-hidden"
                            >
                                <div
                                    className={`relative shrink-0 w-11 h-11 md:w-12 md:h-12 rounded-xl flex items-center justify-center bg-primary/10 ${s.iconColor}`}
                                >
                                    <Icon size={22}/>
                                </div>
                                <div className="relative flex flex-col gap-1 min-w-0">
                                    <h3 className="font-semibold text-sm md:text-base">
                                        {s.title}
                                    </h3>
                                    <p className="text-xs md:text-sm text-muted-foreground leading-relaxed">
                                        {s.desc}
                                    </p>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
